"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFirebase = void 0;
require("firebase/firestore");
require("firebase/storage");
const firestore_1 = require("./firestore");
const storage_1 = require("./storage");
class ClientFirebase {
    constructor(app) {
        this.app = app;
        this.firestore = new firestore_1.Firestore(new firestore_1.RawFirestore(this.app.firestore()));
        this.storage = new storage_1.Storage(this.app);
    }
}
exports.ClientFirebase = ClientFirebase;
